import React from 'react';
import styled, { css } from 'styled-components';
import data from '../Data';
import Card from './card';
import { Black } from '../../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const Wrap = styled.div`
  color: ${Black};
  justify-items: center;
  display: grid;
  grid-column-gap: 1.5rem;
  ${(props) => {
    const { higherEd } = props;

    if (higherEd) {
      return css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        justify-items: center;
        margin-bottom: 40px;
        padding-top: 32px;
      `;
    }
    return null;
  }}

  @media ${breakpointsMinWidth.mobileMd} {
    grid-column: 1/5;
    justify-items: center;
    ${(props) => {
      const { higherEd } = props;

      if (higherEd) {
        return css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        `;
      }
      return null;
    }}
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/8;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
    ${(props) => {
      const { higherEd } = props;

      if (higherEd) {
        return css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding-top: 38px;
        `;
      }
      return null;
    }}
  }

  @media ${breakpointsMinWidth.tabletMd} {
    display: grid;
    grid-column: 2/7;
    height: ${({ higherEd }) => (higherEd ? 'auto' : '596px')};
    grid-row-gap: 18px;
    padding: 0px 0px 18px 0px;
    justify-items: right;
    grid-template-columns: none;
    justify-items: center;

    ${({ higherEd }) => {
      if (higherEd) {
        return css`
          padding-top: 38px;
        `;
      }
      return null;
    }}
  }

  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 3/7;
    justify-items: center;
    ${({ higherEd }) => {
      if (higherEd) {
        return css`
          padding-top: 38px;
        `;
      }
      return null;
    }}
  }

  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: 3/7;
    height: ${({ higherEd }) => (higherEd ? 'auto' : '673px')};
    grid-row-gap: 20px;
    padding: 0px 0px 20px 0px;
    justify-items: center;
    ${({ higherEd }) => {
      if (higherEd) {
        return css`
          padding-top: 50px;
        `;
      }
      return null;
    }}
  }

  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: 3/7;
    height: ${({ higherEd }) => (higherEd ? 'auto' : '824px')};
    grid-row-gap: 24px;
    padding: 0px 0px 24px 0px;
    justify-items: center;
    ${({ higherEd }) => {
      if (higherEd) {
        return css`
          padding-top: 50px;
        `;
      }
      return null;
    }}
  }
`;

const Cards = ({ higherEd }) => {
  const { CardsData } = data;
  const mapData = higherEd ? CardsData.data : CardsData.children;
  return (
    <>
      <Wrap higherEd={higherEd}>
        {mapData.map((child, index) => (
          <Card
            child={child}
            index={index}
            key={child.Key}
            higherEd={higherEd}
          />
        ))}
      </Wrap>
    </>
  );
};

export default Cards;
